"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const React = __importStar(require("react"));
const react_1 = require("react");
const one_1 = require("remax/one");
const popup_1 = __importDefault(require("../popup"));
const selector_1 = __importDefault(require("../selector"));
const form_value_1 = __importDefault(require("../form-value"));
const common_1 = require("../common");
const prefixCls = common_1.getPrefixCls('selector-popup');
const SelectorPopup = (props) => {
    const { placeholder, children, title, onChange } = props;
    const [show, setShow] = react_1.useState(false);
    const handleTap = () => {
        setShow(true);
    };
    const handleClose = () => {
        setShow(false);
    };
    const handleChange = (value, valueStr) => {
        onChange === null || onChange === void 0 ? void 0 : onChange(value, valueStr);
        handleClose();
    };
    return (React.createElement(one_1.View, { className: prefixCls },
        React.createElement(one_1.View, { className: `${prefixCls}-formitem`, onTap: handleTap },
            React.createElement(form_value_1.default, { placeholder: placeholder }, children)),
        React.createElement(popup_1.default, { position: "bottom", title: title, closeable: true, open: show, onClose: handleClose },
            React.createElement(one_1.View, { className: `${prefixCls}-container` },
                React.createElement(selector_1.default, Object.assign({}, props, { style: {
                        height: '540px',
                    }, onChange: handleChange }))))));
};
exports.default = SelectorPopup;
